module.exports = __webpack_public_path__ + "img/smiling_iroh_thumb.3ae4ed6c.jpg";